const devEnvironments = {
  development: {
    api: {
      baseURL: '',
      gatewayURL: 'http://localhost:5001',
    },
    socket: { url: '', apiKey: '' },
    webviewAppURL: 'http://localhost:3000',
    fusionAuth: {
      url: 'https://auth.alpha.tdlt.dev',
      issuer: 'https://auth.alpha.tdlt.dev',
      clientId: '71409f14-1c14-4a6e-8d17-9167f9f9a94c',
      redirectUri: 'http://localhost:3002',
    },
    domain: 'http://localhost:3002',
  },
  // Beta/sandbox APIs with localhost redirect — for local dev against beta
  'beta-local': {
    api: {
      baseURL: 'https://api.beta.tdlt.dev',
      gatewayURL: 'https://sandbox.api.partners.tabadulat.com',
    },
    webviewAppURL: 'https://sandbox.webview.tabadulat.com',
    fusionAuth: {
      url: 'https://auth.beta.tdlt.dev',
      issuer: 'https://auth.beta.tdlt.dev',
      clientId: 'd24e289c-5464-4877-b01f-6ac8ec938efa',
      redirectUri: 'http://localhost:3002',
    },
    domain: 'http://localhost:3002',
  },
  // Alpha APIs with localhost redirect — for local dev against alpha environment
  'alpha-local': {
    api: {
      baseURL: 'https://api.alpha.tdlt.dev',
      gatewayURL: 'https://partners.alpha.tdlt.dev',
    },
    webviewAppURL: 'https://webview-app.alpha.tdlt.dev',
    fusionAuth: {
      url: 'https://auth.alpha.tdlt.dev',
      issuer: 'https://auth.alpha.tdlt.dev',
      clientId: '71409f14-1c14-4a6e-8d17-9167f9f9a94c',
      redirectUri: 'http://localhost:3002',
    },
    domain: 'http://localhost:3002',
  },
  alpha: {
    api: {
      baseURL: 'https://api.alpha.tdlt.dev',
      gatewayURL: 'https://partners.alpha.tdlt.dev',
    },
    webviewAppURL: 'https://webview-app.alpha.tdlt.dev',
    fusionAuth: {
      url: 'https://auth.alpha.tdlt.dev',
      issuer: 'https://auth.alpha.tdlt.dev',
      clientId: '71409f14-1c14-4a6e-8d17-9167f9f9a94c',
      redirectUri: 'https://portal.alpha.tdlt.dev',
    },
    domain: 'portal.alpha.tdlt.dev',
  },
  beta: {
    api: {
      baseURL: 'https://api.beta.tdlt.dev',
      gatewayURL: 'https://partners.beta.tdlt.dev',
    },
    webviewAppURL: 'https://sandbox.webview.tabadulat.com',
    fusionAuth: {
      url: 'https://auth.beta.tdlt.dev',
      issuer: 'https://auth.beta.tdlt.dev',
      clientId: 'PARTNER_PORTAL_CLIENT_ID_TBD',
      redirectUri: 'https://portal.beta.tdlt.dev',
    },
    domain: 'portal.beta.tdlt.dev',
  },
  production: {
    api: {
      baseURL: 'https://api.tabadulat.com',
      gatewayURL: 'https://api.partners.tabadulat.com',
    },
    webviewAppURL: 'https://webview.tabadulat.com',
    fusionAuth: {
      url: 'https://auth.prod.tdlt.dev',
      issuer: 'https://auth.tabadulat.com',
      clientId: 'PARTNER_PORTAL_CLIENT_ID_TBD',
      redirectUri: 'https://portal.prod.tdlt.dev',
    },
    domain: 'portal.prod.tdlt.dev',
  },
};

function getConfig() {
  if (typeof window !== 'undefined' && window.RUNTIME_CONFIG && window.RUNTIME_CONFIG.FUSIONAUTH_CLIENT_ID) {
    return {
      api: {
        baseURL: window.RUNTIME_CONFIG.API_BASE_URL,
        gatewayURL: window.RUNTIME_CONFIG.PARTNER_GATEWAY_URL || window.RUNTIME_CONFIG.API_BASE_URL,
      },
      socket: {
        url: window.RUNTIME_CONFIG.SOCKET_URL || '',
        apiKey: window.RUNTIME_CONFIG.SOCKET_API_KEY || '',
      },
      webviewAppURL: window.RUNTIME_CONFIG.WEBVIEW_APP_URL || '',
      fusionAuth: {
        url: window.RUNTIME_CONFIG.FUSIONAUTH_URL,
        issuer: window.RUNTIME_CONFIG.FUSIONAUTH_ISSUER || window.RUNTIME_CONFIG.FUSIONAUTH_URL,
        clientId: window.RUNTIME_CONFIG.FUSIONAUTH_CLIENT_ID,
        redirectUri: window.RUNTIME_CONFIG.FUSIONAUTH_REDIRECT_URI,
      },
      domain: window.RUNTIME_CONFIG.DOMAIN,
      environment: window.RUNTIME_CONFIG.ENVIRONMENT,
      isDevelopment: window.RUNTIME_CONFIG.ENVIRONMENT === 'development',
      isProduction: window.RUNTIME_CONFIG.ENVIRONMENT === 'production',
    };
  }

  const env = process.env.REACT_APP_ENV || process.env.NODE_ENV || 'development';
  const base = devEnvironments[env] || devEnvironments.development;

  return {
    ...base,
    socket: {
      url: process.env.REACT_APP_SOCKET_URL || base.socket?.url || '',
      apiKey: process.env.REACT_APP_SOCKET_API_KEY || base.socket?.apiKey || '',
    },
    environment: env,
    isDevelopment: env === 'development',
    isProduction: env === 'production',
  };
}

export default getConfig;
